
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/energy",
      function () {
        return require("private-next-pages/use-cases/energy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/energy"])
      });
    }
  